// Spanish translation

const es = {
  "menu.housekeeping": "AMA DE LLAVES",
  "hotel.room": "Ama de Llaves",
  "hotel.room.state": "Estado",
  "hotel.room.name": "Hab.",
  "hotel.room.current_guests": "Huésped Actual",
  "hotel.room.cleaning_type": "Tipo Limpieza",
  "hotel.room.type_": "Tipo",
  "hotel.room.last_check_in": "Ult. Check-In",
  "hotel.room.last_check_out": "Ult. Check-Out",
  "hotel.room.last_clean": "Ult. Limpieza",
  "hotel.room.occupied_today": "Ocupadas Hoy",
  "hotel.room.notes": "Notas",
  "hotel.room.dirty": "Sucia",
  "hotel.room.clean": "Limpia",
  "hotel.room.not_authorized": "No Autor.",
  "hotel.room.inspected": "Inspecc.",
  "hotel.room.all": "Todas",
  "hotel.room.maintenance": "Manten.",
  "hotel.room.location": "Locación",
  "hotel.room.check_out_today": "Check Out Hoy",
  "hotel.room.arrival_today": "Llegada Hoy",
  "hotel.room.check_in_today": "Check In Hoy",
  "hotel.room.departure_today": "Salida Hoy",
  "hotel.room.housekeeping": "Ama de Llaves",
  "housekeeping.wizard_schedule.reset_all": "Borrar la programación",
  "hotel.room.add_room": "Agregar Habitación",
  "hotel.room.type_.filter": "Filtrar Tipo",
  "hotel.room.location.filter": "Filtrar Locación",
  "housekeeping.description_report": "Reporte Ama de Llaves",
  "schedule.wizard_schedule.title": "Programación Ama de Llaves",
  "schedule.wizard_schedule.create": "Programación",
  "schedule.wizard_schedule.save": "Guardar",
  "schedule.wizard_schedule.close": "Cerrar",
  "schedule.wizard_schedule.msg_room": "Seleccione al menos una habitación",
  "schedule.wizard_schedule.msg_employee": "Seleccione al menos un empleado",
  "schedule.wizard_schedule.msg_reset_ok": "Registros borrados correctamente",
  "schedule.wizard_schedule.msg_schedule_ok":
    "Asignación completada exitosamente",
  "hotel.room.locations": "LOCACIONES",
  "hotel.room.tweak": "Retoque",
  "hotel.room.deep": "Profunda",
  "hotel.room.standard": "Estandar",
  "hotel.room.occupied": "Ocupada",
  "hotel.room.vacancy": "Vacante",
  "hotel.room.departure": "Salida",
  "hotel.housekeeping.msg_now_room_is_dirty": "Ahora la habitación esta sucia!",
  "hotel.housekeeping.msg_now_room_is_clean":
    "Ahora la habitación esta limpia!",
  "hotel.housekeeping.msg_now_room_is_maintenance":
    "Ahora la habitación esta en mantenimiento!",
  "hotel.housekeeping.msg_now_room_is_not_auth":
    "Ahora la habitación se marco como no autorizada!",
};

export default es;
